import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AddPlusSvg } from "../../svgs/addPlusSvg";
import { RemoveIcon1Svg } from "../../svgs/removeIcon1Svg";
import PLANS from "../../api/services/PLANS";
import styles from "../../styles/_containers/_memberships/items.module.scss";
import Loader from "../../components/loader";
import { toast } from "react-toastify";

const Items = () => {
  const navigate = useNavigate();
  const [allPlans, setAllPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resSuccess, setResSuccess] = useState(null);

  // FETCH PLANS
  useEffect(() => {
    setResSuccess(null);
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await PLANS.get_all_plans();
        setAllPlans(res.data.plans);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    };

    fetchData();
  }, [resSuccess]);

  if (loading) {
    return (
      <div className={styles.container}>
        <Loader />
      </div>
    );
  }

  if (!loading && allPlans?.length === 0) {
    return (
      <div className={styles.emptyState}>
        <img src="/assets/books-icon-1.svg" alt="no memberships" className={styles.emptyIcon} />
        <h3 className={styles.emptyTitle}>עדיין אין מנויים</h3>
        <p className={styles.emptyText}>צור את המנוי הראשון שלך ותתחיל להציע ללקוחות שלך חבילות מותאמות</p>
        <button
          className={styles.emptyBtn}
          onClick={() => navigate("/memberships?new=1")}
        >
          + צור מנוי חדש
        </button>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {allPlans?.map((i) => (
        <Item
          key={i._id}
          id={i._id}
          title={i.name}
          isSubscription={i.isSubscription}
          numberOfTurns={i.numberOfTurns}
          price={i.price}
          expiresIn={i.expiresIn}
          setResSuccess={setResSuccess}
        />
      ))}
    </div>
  );
};

export default Items;

const Item = ({
  id,
  title,
  isSubscription,
  numberOfTurns,
  price,
  expiresIn,
  setResSuccess,
}) => {
  // DELETE PLAN
  const handleDelete = async () => {
    try {
      await PLANS.deletePlan(id);
      toast.success("המנוי נמחק בהצלחה");
      setResSuccess(true);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "שגיאה במחיקת המנוי");
    }
  };

  // EXTRACT THE LAST CHARACTER OF STRING
  let lastChar = expiresIn.slice(expiresIn.length - 1);

  return (
    <div className={styles.item}>
      <div className={styles.top}>
        <div className={styles.title}>
          <h3>
            {title} | <span>{isSubscription ? "מנוי" : "כרטיסיה"}</span>
          </h3>
        </div>
        <hr />
        <ul>
          <li>
            <AddPlusSvg fill="#06A816" />
            <p>כמות כניסות - {numberOfTurns}</p>
          </li>
          <li>
            <AddPlusSvg fill="#06A816" />
            <p>
              תוקף המינוי - 3{" "}
              {lastChar === "d"
                ? "ימים"
                : lastChar === "w"
                ? "שבועות"
                : lastChar === "m"
                ? "חודשים"
                : lastChar === "y"
                ? "שנים"
                : ""}
            </p>
          </li>
          <li>
            <AddPlusSvg fill="#06A816" />
            <p>מחיר - ₪{price}</p>
          </li>
        </ul>
      </div>
      <div className={styles.bottom} onClick={handleDelete}>
        <RemoveIcon1Svg fill="#ffffff" />
        <p>מחיקת מינוי</p>
      </div>
    </div>
  );
};
